import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SEO from '../components/seo';
import Sidebar from '../components/Sidebar';
import 'emerald-ui/lib/styles.css';
import '../index.css';

import { version } from '../data/components/utils/propDescriptions.json';
import githubLogo from '../images/github-logo.svg';
import githubLogoWhite from '../images/github-logo-white.svg';
import storybookLogo from '../images/storybook-logo.svg';
import storybookLogoWhite from '../images/storybook-logo-white.svg';
import npmLogo from '../images/npm-logo.svg';
import npmLogoWhite from '../images/npm-logo-white.svg';
import logoGem from '../images/emerald-logo-gem.svg';
import logoLetters from '../images/emerald-logo-letters.svg';
import { LiveProvider, LiveEditor } from 'react-live';
import { theme } from '../components/CodeSample/theme';
import ThemeButton from '../components/ThemeButton';
import classnames from 'classnames';

import tinykeys from 'tinykeys';
import Credits from '../components/Credits';
import Table from 'emerald-ui/lib/Table/Table';
import IconButton from 'emerald-ui/lib/IconButton/IconButton';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Toast from 'emerald-ui/lib/Toast/Toast';
import { useThemeStore } from '../state/themeStore';

// import productFoundationsIllustration from '../images/product-foundations.svg';
// import patternsIllustration from '../images/patterns.svg';
// import cebLogo from '../images/ceb.svg';
// import ecLogo from '../images/ec.svg';

function CodeSample(props) {
  const themeState = useThemeStore((state) => state.theme);

  const newTheme = { ...theme };

  if (themeState === 'dark') {
    newTheme.plain.backgroundColor = '#10161A';
  }

  return (
    <LiveProvider disabled code={props.children} theme={newTheme}>
      <LiveEditor padding={20} style={{ margin: '20px 0' }} />
    </LiveProvider>
  );
}

CodeSample.propTypes = {
  children: PropTypes.any,
};

function ColorRow({ color, lightCode, darkCode, setToastVisible, forceColor, forceCaption, forceTextCopy }) {
  const style = {};

  if (forceColor) {
    style.color = forceColor;
  }

  function handleCopy() {
    setToastVisible(true);

    setTimeout(() => {
      setToastVisible(false);
    }, 3000);
  }

  return (
    <tr>
      <td className="color-cell">
        <i className={`material-icons color-circle ${forceColor ? '' : color}`} style={style}>
          circle
        </i>
        <span className="color-name">{forceCaption || color}</span>
        <CopyToClipboard text={forceTextCopy || color} onCopy={handleCopy}>
          <IconButton icon="content_copy" title="Copy to clipboard" />
        </CopyToClipboard>
      </td>
      <td className="font-mono">{lightCode}</td>
      <td className="font-mono">{darkCode}</td>
    </tr>
  );
}

ColorRow.propTypes = {
  color: PropTypes.string,
  lightCode: PropTypes.string,
  darkCode: PropTypes.string,
  setToastVisible: PropTypes.func,
  forceColor: PropTypes.string,
  forceCaption: PropTypes.string,
  forceTextCopy: PropTypes.string,
};

function IndexPage() {
  const theme = useThemeStore((state) => state.theme);

  const [credits, setCredits] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);

  useEffect(() => {
    const unsubscribe = tinykeys(window, {
      'g g h': () => {
        window.open('https://github.com/cebroker/emerald-ui');
      },
      'g s b': () => {
        window.open('https://storybook-emerald.condorlabs.io');
      },
      'ArrowUp ArrowUp ArrowDown ArrowDown ArrowLeft ArrowRight ArrowLeft ArrowRight KeyB KeyA': () => {
        setCredits(true);
      },
    });

    return () => {
      unsubscribe();
    };
  }, []);

  function handleActionClick() {
    setToastVisible(false);
  }

  return (
    <div
      className={classnames('main-content', {
        'dark-theme': theme === 'dark',
        // animate: theme.animate,
        'show-credits': credits,
      })}
    >
      <Credits />
      <SEO title="Home" keywords={[`emerald-ui`, `components library`, `react`, 'documentation']} />
      <Sidebar className="from-welcome-screen" />
      <div className="welcome-screen">
        <div className="top-bar" />
        <div className="hero">
          <div className="docs-container" style={{ textAlign: 'center' }}>
            <div className="logo">
              <img src={logoGem} alt="Emerald UI logo gem" className="gem" />
              <img src={logoLetters} alt="Emerald UI" className="letters" />
            </div>
            <p>A living collection of design systems and patterns</p>
          </div>
        </div>
        <div className="welcome-screen-container">
          <div className="docs-container">
            <div className="card-grid">
              {/*   <a
        className="eui-card"
        href="http://emeraldui.com/Foundations_Implimentation_principles"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={productFoundationsIllustration}
          className="card-illustration"
          alt=""
        />
        <div>
          <h4>Product foundations</h4>
          <p>
            An overview of the color, type, and visual styles used to shape
            our products.
          </p>
        </div>
      </a>
      <Card>
        <div style={{ width: '100%' }}>
          <h4>Brand guidelines</h4>
          <p>Explore our brand style guides.</p>
          <div className="products-list">
            <a
              href="http://emeraldui.com/CE_Broker_Illustration"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={cebLogo} alt="CE Broker" />
            </a>
            <a
              href="http://emeraldui.com/Evercheck_Illustration"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ecLogo} alt="EverCheck" />
            </a>
          </div>
        </div>
      </Card>
      <a
        className="eui-card"
        href="http://emeraldui.com/Patterns_Accessibility"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={patternsIllustration}
          alt=""
          className="card-illustration"
        />
        <div>
          <h4>Patterns</h4>
          <p>See how components come together to form standard patterns.</p>
        </div>
      </a> */}
            </div>
            <div className="installation-container">
              {/* <img
        src={componentsIllustration}
        alt=""
        className="card-illustration"
      /> */}
              <div className="installation">
                <div>
                  <h4>v{version}</h4>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div className="btn-toolbar">
                      <a
                        className="githubLink"
                        href="https://github.com/cebroker/emerald-ui"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ marginRight: '15px' }}
                      >
                        <img src={theme === 'dark' ? githubLogoWhite : githubLogo} alt="Github link" />
                      </a>
                      <a
                        className="storybookLink"
                        href="https://storybook-emerald.condorlabs.io"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ marginRight: '15px' }}
                      >
                        <img src={theme === 'dark' ? storybookLogoWhite : storybookLogo} alt="Storybook link" />
                      </a>
                      <a
                        className="npmLink"
                        href="https://www.npmjs.com/package/emerald-ui"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={theme === 'dark' ? npmLogoWhite : npmLogo} alt="NPM link" />
                      </a>
                    </div>
                    <ThemeButton />
                  </div>
                </div>
                <p style={{ marginTop: '40px', marginBottom: 0 }}>
                  <strong>NEW</strong> Check out the <a href="#text-colors">text colors.</a>
                </p>
                <h2>Installation</h2>
                <p>1. Install emerald-ui.</p>
                <pre style={{ marginBottom: '30px' }}>npm i emerald-ui</pre>
                <p>2. Import the appropriate styles in your App.js or main js file.</p>
                <ul>
                  <li>
                    Import the base styles (mandatory):
                    <CodeSample>{`import 'emerald-ui/lib/styles.css';`}</CodeSample>
                  </li>
                  <li>
                    For the CE Broker styles:
                    <CodeSample>{`import 'emerald-ui/lib/styles-ceb.css';`}</CodeSample>
                  </li>
                  <li>
                    For the EverCheck styles:
                    <CodeSample>{`import 'emerald-ui/lib/styles-ec.css';`}</CodeSample>
                  </li>
                  <li>
                    For the Table Mesa styles:
                    <CodeSample>{`import 'emerald-ui/lib/styles-tm.css';`}</CodeSample>
                  </li>
                </ul>
                <p>
                  Note that if you want to apply the CE Broker, EverCheck or Table Mesa styles, you need to also import
                  the Emerald-UI base styles. First, import the base styles, then import the product specific styles.
                </p>
                <hr />
                <h2 style={{ marginTop: '40px' }}>Dark Theme</h2>
                <p>In order to activate the Dark Theme you only need to do the following two steps</p>
                <ul>
                  <li>
                    Import the default Dark Theme styles:
                    <CodeSample>{`import 'emerald-ui/lib/dark-theme.css'`}</CodeSample>
                  </li>
                  <li>
                    Or the CE Broker Dark Theme styles:
                    <CodeSample>{`import 'emerald-ui/lib/dark-theme-ceb.css'`}</CodeSample>
                  </li>
                  <li>
                    Or the EverCheck Dark Theme styles:
                    <CodeSample>{`import 'emerald-ui/lib/dark-theme-ec.css'`}</CodeSample>
                  </li>
                  <li>
                    Add the class <span className="code">eui-dark-theme</span> to the body or outermost container.
                  </li>
                </ul>
                <p>
                  There might be instances in which you need to apply the dark theme to a component or a group of
                  components even if the global theme is the regular, light one. In order to achieve this, wrap the
                  component(s) in a div with a className of <span className="code">eui-dark-theme no-bg</span>. This
                  will add the dark theme styles to the inner components, except for the contextual components like the
                  Popover, DropdownMenu and Calendar, which will keep the light theme styles.
                </p>
                <hr />
                <h2 id="text-colors" style={{ marginTop: '40px' }}>
                  Text color classes
                </h2>
                <p>
                  There are a series of classes that must be used when coloring text. This is important because when the
                  colors change, you won&apos;t have to do anything in the code. Note that the color codes are displayed
                  here only for reference and should not be used directly. <strong>Use the classes</strong> instead.
                  These are the classes:
                </p>
                <div style={{ overflow: 'auto', maxWidth: '100vw' }}>
                  <Table className="text-color-table">
                    <thead>
                      <tr>
                        <th style={{ visibility: 'hidden' }}>Color</th>
                        <th>Light theme</th>
                        <th>Dark theme</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ColorRow
                        color="text-dark"
                        lightCode="#1D2121"
                        darkCode="rgba(255, 255, 255, 0.87)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-color"
                        lightCode="#282e2e"
                        darkCode="rgba(255, 255, 255, 0.6)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-light"
                        lightCode="#4b5353"
                        darkCode="rgba(255, 255, 255, 0.4)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-lighter"
                        lightCode="#607b7b"
                        darkCode="rgba(255, 255, 255, 0.3)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-lightest"
                        lightCode="#abbdbd"
                        darkCode="rgba(255, 255, 255, 0.5)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-off-white"
                        lightCode="#f9fafc"
                        darkCode="rgba(255, 255, 255, 0.5)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-off-white-dark"
                        lightCode="#f3f6f6"
                        darkCode="rgba(255, 255, 255, 0.8)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-off-white-darker"
                        lightCode="#e6e8ec"
                        darkCode="rgba(255, 255, 255, 0.1)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-off-white-darkest"
                        lightCode="#bec6c6"
                        darkCode="rgba(255, 255, 255, 0.1)"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-primary"
                        lightCode="#0f3166"
                        darkCode="#9badcd"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-info"
                        lightCode="#0073e9"
                        darkCode="#8ccbff"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-success"
                        lightCode="#00a950"
                        darkCode="#9adcad"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-warning"
                        lightCode="#ffaa00"
                        darkCode="#fef697"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-danger"
                        lightCode="#de350b"
                        darkCode="#ffa88e"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#0073e9"
                        darkCode="#0073e9"
                        setToastVisible={setToastVisible}
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#168757"
                        darkCode="#168757"
                        setToastVisible={setToastVisible}
                        forceColor="#168757"
                        forceCaption="text-brand (For CEB)"
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#3fda97"
                        darkCode="#3fda97"
                        setToastVisible={setToastVisible}
                        forceColor="#3fda97"
                        forceCaption="text-brand (For EC)"
                      />
                    </tbody>
                  </Table>
                </div>
                <h2 style={{ marginTop: '40px' }}>Other color classes</h2>
                <p>
                  You can use the following classes to change css properties depending on the brand you&apos;re using:
                </p>
                <div style={{ overflow: 'auto', maxWidth: '100vw' }}>
                  <Table className="text-color-table">
                    <thead>
                      <tr>
                        <th style={{ visibility: 'hidden' }}>Color</th>
                        <th>Light theme</th>
                        <th>Dark theme</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ColorRow
                        color="text-brand"
                        lightCode="#0073e9"
                        darkCode="#0073e9"
                        setToastVisible={setToastVisible}
                        forceCaption="bg-brand"
                        forceTextCopy="bg-brand"
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#0073e9"
                        darkCode="#0073e9"
                        setToastVisible={setToastVisible}
                        forceCaption="border-brand"
                        forceTextCopy="border-brand"
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#168757"
                        darkCode="#168757"
                        setToastVisible={setToastVisible}
                        forceColor="#168757"
                        forceCaption="bg-brand (for CEB)"
                        forceTextCopy="bg-brand"
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#168757"
                        darkCode="#168757"
                        setToastVisible={setToastVisible}
                        forceColor="#168757"
                        forceCaption="border-brand (for CEB)"
                        forceTextCopy="border-brand"
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#3fda97"
                        darkCode="#3fda97"
                        setToastVisible={setToastVisible}
                        forceColor="#3fda97"
                        forceCaption="bg-brand (for EC)"
                        forceTextCopy="bg-brand"
                      />
                      <ColorRow
                        color="text-brand"
                        lightCode="#3fda97"
                        darkCode="#3fda97"
                        setToastVisible={setToastVisible}
                        forceColor="#3fda97"
                        forceCaption="border-brand (for EC)"
                        forceTextCopy="border-brand"
                      />
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toast
        message="Color copied to clipboard"
        actionText="OK"
        position="right"
        onActionClick={handleActionClick}
        visible={toastVisible}
      />
    </div>
  );
}

export default IndexPage;
